export function normalizeFontFamily(fontFamily?: string | null) {
  if (!fontFamily) return ``;

  return fontFamily.replace(/["']/g, ``).replace(/\s+/g, ` `).trim().toLowerCase();
}

export const fontFamilies = [
  { label: `Calibri`, value: `Calibri, sans-serif` },
  { label: `Arial`, value: `Arial, sans-serif` },
  { label: `Helvetica Neue`, value: `"Helvetica Neue", Helvetica, Arial, sans-serif` },
  { label: `Helvetica Neue Light`, value: `"Helvetica Neue Light", "HelveticaNeue-Light", "Helvetica Neue", Helvetica, Arial, sans-serif` },
  { label: `Helvetica`, value: `Helvetica, Arial, sans-serif` },
  { label: `Verdana`, value: `Verdana, sans-serif` },
  { label: `Tahoma`, value: `Tahoma, sans-serif` },
  { label: `Trebuchet MS`, value: `"Trebuchet MS", sans-serif` },
  { label: `Georgia`, value: `Georgia, serif` },
  { label: `Times New Roman`, value: `"Times New Roman", serif` },
  { label: `Courier New`, value: `"Courier New", monospace` },
].map(fontFamily => ({
  ...fontFamily,
  normalizedValue: normalizeFontFamily(fontFamily.value),
}));

export function sanitizeFontFamily(fontFamily?: string | null) {
  const normalizedValue = normalizeFontFamily(fontFamily);

  if (!normalizedValue) return null;

  const found = fontFamilies.find(f => f.normalizedValue === normalizedValue);

  return found?.value || null;
}
